export const AppConstants = {
    APP_DB_NAME: 'Upoint_DB',
    APP_INIT_TABLE: 'general',
    INDEX_DB_VERSION: 1,
    APP_SESS_TOKEN_NAME: 'alightSecureSessionToken',
    APP_PERSON_TOKEN_NAME: 'alightPersonSessionToken',
    UPN_Error_Logs: 'UPN_Error_Logs',
    PRE_AUTH_SESSION_VALUES: ['enableDynamicURL', 'serviceClients', 'app_url', 'alightRequestHeader', 'ADOPT_UPOINT_REDESIGN', 'ga_json', 'brandingObj', 'UI_REFRESH_2019_ENABLED', 'UI_REFRESH_2019_FONT_ENABLED', 'transmit.url', 'gatewayUrl', 'expValueMap', 'aonAuthElapsedTime', 'THRIVE_CLIENT_BRANDING_ENABLED', 'THRIVE_ON_CLASSIC_PREAUTH_EXPR', 'INAPP_BROWSER_HIDE_HEADER_FOOTER', 'MOBILE_SMART_APP_BANNER_EXPR', 'pageUtilityData', 'gatewayUrlOverridden', 'activeLifecycle', 'IS_IVA_LIFERAY_ELIG', 'IS_UPN_ROLESACCNTS_ENABLED', 'upnFeedback', 'enableSwDynamicCache', 'swconf']
};
